module.exports = __webpack_public_path__ + "img/CS-Hybrid_Overview-EC_2.3b0dd4d5.jpg";